export default "__VITE_ASSET__IDg_qEzt__"